import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RenderOtxCandidateService } from 'src/app/service/render-otx-candidate.service';

@Component({
  selector: 'app-repair-post-repair-candidate',
  templateUrl: './repair-post-repair-candidate.component.html',
  styleUrls: ['./repair-post-repair-candidate.component.scss']
})
export class RepairPostRepairCandidateComponent implements OnInit {

  public candidateId:string ='';
  public candidateKind='';
  public candidateProcUid='';
  public userId: any;
  public sessionId:any;
  public qidRes:any;
  public res:any;
  public invinnumber=''
  public isNetwork=false;
  tokenObj:any;
  language: any;
  countryCode: any;
  queueId: any;
  candidateData: any;
  public previousScreen: string = '';
  public selectedId: string = '';
  public btnName: string = '';
  fromResume=false;
  pageData:any;
  procedureType: string = '';
  constructor(private service: ApifirstService,private renderOtxCandidateService: RenderOtxCandidateService) { }

  ngOnInit(): void {
    this.service.setShowWhatsNew(false);
    this.service.userId.subscribe((data) => {
      this.userId = data
    })
    this.service.candidateId.subscribe((data) => {
      this.candidateId = data
    })
    this.service.candidateKind.subscribe((data) => {
      this.candidateKind = data
    })
    this.service.candidateProcUid.subscribe((data) => {
      this.candidateProcUid = data
    })
    this.service.selectedDiagnosticProcedureData$.subscribe((data) => {
      this.candidateData = data;
    })

    this.service.navigatePreviousScreen.subscribe((data)=> {
      if(data == 'repairProcedure') {
        this.btnName = "REPAIR CANDIDATES "
        this.procedureType = "REPAIR"
      } else if (data == 'postRepairProcedure') {
        this.btnName = "POST REPAIR CANDIDATES"
        this.procedureType = "POST_REPAIR"
      }
    })

    this.service.navigatetoPreviousScreen.subscribe((data) => {
      this.manipulatePreviousScreenData(data)
    })
    this.renderOtxCandidate();
  }

  manipulatePreviousScreenData(data: any) {
    this.previousScreen = data.screen;
    this.selectedId = data.id;
  }

  renderOtxCandidate() {
    console.log('renderOtxCandidateOTX:', this.candidateId);
    this.service.tokenObj.subscribe((data)=>{
      this.res = data;
      this.invinnumber = this.res.vin
      this.language= this.res.language.toLowerCase()
      this.countryCode =this.res.country
      this.sessionId=localStorage.getItem("sessionID")

      let reqBodyForSessionId=
        {
          "sessionId" : this.sessionId
        }
     console.log("req", this.language, this.countryCode, reqBodyForSessionId);
     this.getQueueId(this.language, this.countryCode, reqBodyForSessionId);
    })
  }

  getQueueId(language: string, countryCode: string, reqBodyForSessionId: any) {
    this.service.queueIdRes(language, countryCode, reqBodyForSessionId,this.candidateId, this.procedureType).subscribe((data) => {
      console.log('otx popup called:');
      this.qidRes = data;
      this.renderOtxCandidateService.tryFDTConnection(this.candidateId,this.qidRes );

  })
  }

}
